import { useCallback } from "react";
import { useMarket } from "./MarketProvider";
import { withMarket } from "./markets";

/**
 * Turn an app path into one that keeps the visitor in their market:
 * `to("/search")` is "/eg/search" under /eg/, and "/search" without a prefix.
 *
 * Every internal link in the v3 screens goes through this. A link that drops
 * the prefix silently moves the visitor to the default market, which is the
 * kind of bug nobody reports because it looks like it worked.
 */
export function useMarketLink(): (path: string) => string {
  const { slug } = useMarket();
  return useCallback((path: string) => withMarket(path, slug), [slug]);
}

/* Where "List your property" goes. The design's header, band and empty state
 * all point here, and since rebuild-1(4d) the screen exists. It pointed at
 * the panel's posting flow while it did not -- a real door rather than a 404
 * wearing a working button's clothes. */
export const LIST_PROPERTY_PATH = "/list-property";
